import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { BenefitHospitalNetworkAction } from '../APIs/action';
import NetworkHospitalCard from './NetworkHospitalCard';
import SearchIcon from '@mui/icons-material/Search';
import { CustomSelect, TextField } from '../../../MUI_custom_component';
import IconReusable from '../../../../components/IconReusable';

const NetworkHospitalPage = () => {
  const [loader, setLoader] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [hospitalListMap, setHospitalListMap] = useState({});
  const [selectedState, setSelectedState] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const BenefitHospitalNetwork = async () => {
    setLoader(true);
    const { data, message, error } = await BenefitHospitalNetworkAction();
    setLoader(false);
    if (!error) {
      setAllStates(data.state_list || []);
      setHospitalListMap(data.hospital_state_wise_map || {});
      // setSelectedState(data.state_list?.[0] || '');
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    BenefitHospitalNetwork();
  }, []);

  useEffect(() => {
    setSearchTerm('');
  }, [selectedState]);

  const filteredHospitals =
    hospitalListMap[selectedState]?.filter((hospital) =>
      hospital?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
    ) || [];

  if (loader) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 },
      display: 'flex',
      flexDirection:'column',
      gap: 2
    }}>
      <Typography
        variant='h2'
      >
        Cashless Network Hospitals
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{ alignItems: 'end' }}
      >
        <Grid
          item
          xs={12}
          sm={6}
        >
          <CustomSelect
            label="State"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            size='small'
            placeholder='Search State'
            displayEmpty
            fullWidth
            renderValue={(selected) => {
              if (selected === "") {
                return <span style={{ color: "#666" }}>Search State</span>;
              }
              return selected;
            }}
          >
            <MenuItem value="" disabled>
              Search State
            </MenuItem>
            {allStates?.map((state) => (
              <MenuItem
                key={state}
                value={state}
              >
                {state}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <Box sx={{ height: { xs: 0, sm: '14px' } }} />

          <TextField
            placeholder='Search Hospitals'
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
      </Grid>

      {(filteredHospitals.length !== 0) && (
        <Typography
          variant='body1'
          sx={{ fontWeight: '600' }}
        >
          {filteredHospitals.length} Hospitals found.
        </Typography>   
    )}  
      {(filteredHospitals.length === 0) && (
        <Box sx={{ display:'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', mt: 5, gap: 2 }}>
        <IconReusable name="ManageSearch" size={64} color="#995A00" />
        <Typography variant='body1'>
          Please select state to view hospitals.
        </Typography>
        </Box>
      )}  
     
      {selectedState &&
        filteredHospitals.map((hospital, idx) => (
          <NetworkHospitalCard
            key={hospital?.id || idx}
            hospital={hospital}
            idx={idx}
          />
        ))}
    </Box>
  );
};

export default NetworkHospitalPage;
